/** @format */

import {
	Accordion,
	AccordionSummary,
	Typography,
	AccordionDetails,
	ListItemText,
	List,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { colors } from "../../utility/types/constant";

interface FaqSection {
	title: string;
	answer?: string;
	sections?: Array<{
		subtitle: string;
		content: string;
	}>;
}

export default function FAQ() {
	const { t } = useTranslation("pages");

	const whyUseFundsyFi = t("faq.whyUseFundsyFi", {
		returnObjects: true,
	}) as FaqSection;
	const typesOfCircles = t("faq.typesOfCircles", {
		returnObjects: true,
	}) as FaqSection;
	const legalCompliance = t("faq.legalCompliance", {
		returnObjects: true,
	}) as FaqSection;
	const trustSafety = t("faq.trustSafety", {
		returnObjects: true,
	}) as FaqSection;
	const paymentMethods = t("faq.paymentMethods", {
		returnObjects: true,
	}) as FaqSection;
	const payoutMethods = t("faq.payoutMethods", {
		returnObjects: true,
	}) as FaqSection;
	const feesInfo = t("faq.feesInfo", { returnObjects: true }) as FaqSection;
	const definition = t("faq.definition", { returnObjects: true }) as FaqSection;

	const renderAccordion = (
		id: string,
		section: FaqSection,
		bold?: boolean
	) => {
		if (!section?.title) return null;
		return (
			<Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls={`${id}-content`}
					id={`${id}-header`}>
					<Typography
						sx={{
							fontFamily: "'Montserrat', sans-serif",
							fontSize: "18px",
							fontWeight: 850,
						}}>
						{section.title}
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{section.answer ? (
						<Typography variant="body1">{section.answer}</Typography>
					) : section.sections && section.sections.length > 0 ? (
						<List sx={{ listStyleType: "disc" }}>
							{section.sections.map((item, idx) => (
								<ListItemText key={idx} sx={{ display: "list-item", ml: 3 }}>
									{bold ? (
										<>
											<span
												style={{
													fontWeight: "bold",
													color: colors.secondPrimary,
												}}>
												{item.subtitle}:
											</span>{" "}
											{item.content}
										</>
									) : (
										item.content
									)}
								</ListItemText>
							))}
						</List>
					) : null}
				</AccordionDetails>
			</Accordion>
		);
	};

	return (
		<div>
			{renderAccordion("why", whyUseFundsyFi)}
			{renderAccordion("types", typesOfCircles)}
			{renderAccordion("legal", legalCompliance)}
			{renderAccordion("trust", trustSafety)}
			{renderAccordion("payment", paymentMethods, true)}
			{renderAccordion("payout", payoutMethods, true)}
			{renderAccordion("fees", feesInfo)}
			{renderAccordion("definition", definition)}
		</div>
	);
}
